import React from 'react';
import {connect} from 'react-redux';
import {change, Field} from "redux-form";
import {FormattedMessage, injectIntl} from "react-intl";

import {FormCheckBoxField} from "./FormField";
import {store} from "../../main";
import {AccessRights} from "../../schemas/accessRightsModel";
import {getMasterProfile} from "./accountPageFunctions";
import {showFabricatorsPopup} from "../../actions";
import {salesPersonPopupActions} from "../PageLayout/Popups/AssignSalesPersonPopup";
import {showAssignEntityPopup, showPermissionsPopup, setResetPasswordPopup} from "../../actions/A_Popups";
import {addNewQuote} from "./AccountActions";

class AccountPageTopPanel extends React.Component {

  currentEntityForAR = () => {
    const {isCustomer, isEmployee, isFabricator} = this.props.accountPageInfo;
    if (isEmployee)
      return this.props.AR.employee(this.props.customerInfo);
    if (isCustomer)
      return this.props.AR.customer(this.props.customerInfo);
    if (isFabricator)
      return this.props.AR.fabricator(this.props.customerInfo);
  }

  updateCheckBoxField = (input) => {
    store.dispatch(change('newEntity', input.name, !input.value));
  };

  masterProfileButtonClick = () => {
    const id = this.props.assignedMasterProfile ? this.props.assignedMasterProfile.id : 0;
    this.props.showFabricatorsPopup(true, salesPersonPopupActions.setMasterProfile, id);
  };

  createQuoteClick = () => {
    this.props.addNewQuote(this.props.accountPageInfo.entityId, this.props.intl);
  };

  handleShowPopupEx = (popupName) => {
    const {formValues, intl} = this.props;
    const {entityType, isCustomer} = this.props.accountPageInfo;
    const user = {
      id: formValues.id,
      name: `${formValues.firstName} ${formValues.lastName}`
    };

    switch (popupName) {
      case "permissions":
        this.props.showPermissionsPopup({
          showPopup: true,
          user,
          entityType,
          handleClosePopup: () => this.props.showPermissionsPopup({showPopup: false})
        });
        break;
      case "fabricators": {
        const headerText = isCustomer
          ? `${intl.formatMessage({id: "assignEntityPopup.addFabricatorToCustomer"})}: ${user.name}`
          : `${intl.formatMessage({id: "assignEntityPopup.addFabricatorsToFabricator"})}: ${user.name}`
        this.props.showAssignEntityPopup({
          entityId: user.id,
          entityType: isCustomer ? 'customer' : 'fabricator',
          visible: true,
          entitiesType: 'fabricators',
          headerText,
          storePath: 'fabricators'
        });
        break;
      }
      case "stores":
        this.props.showAssignEntityPopup({
          entityId: user.id,
          entityType: 'fabricator',
          visible: true,
          entitiesType: 'stores',
          headerText: `${intl.formatMessage({id: "assignEntityPopup.addStoresToFabricator"})}: ${user.name}`,
          storePath: 'stores'
        });
        break;
      case "resetPassword":
      case "changePassword":
        this.props.setResetPasswordPopup({
          showPopup: true,
          user,
          popupName
        })
        break;
      default:
        throw `Unknown popup ${popupName}`;
    }

  }

  render() {

    const {entityId, canAddFabricator, isCustomer, isFabricator, isEmployee, canChangePassword, isNew, isMasterFabricator} = this.props.accountPageInfo;
    const {isMaster} = this.props.masterProfile;
    const showMasterProfileSelection = this.props.AR.isSiteAdmin() && !isCustomer && !isFabricator;

    return (
      <div className="acc-panel text-center nowrap flex flex--center flex--end flex--wrap">
        {entityId ? (
          <div className="acc-panel__block">
            <div className="acc-panel__block-title"><FormattedMessage id="account.topPanel.toggleUser"/></div>
            <Field name="enabled" component={FormCheckBoxField} onChecked={this.updateCheckBoxField}
                   disabled={this.currentEntityForAR().isEnabledCheckBoxDisabled()}/>
          </div>
        ) : null}
        {!isMaster && isEmployee ? (
          <div className="acc-panel__block">
            <div className="acc-panel__block-title"><FormattedMessage id="account.topPanel.licensedAdmin"/></div>
            <Field name="isLicensedAdmin" component={FormCheckBoxField} onChecked={this.updateCheckBoxField}
                   disabled={this.currentEntityForAR().isLicensedAdminCheckBoxDisabled()}/>
          </div>
        ) : null}
        {this.currentEntityForAR() && this.currentEntityForAR().canSeePermissionsButton() ? (
          <div className="acc-panel__block">
            <div className="acc-panel__block-title"><FormattedMessage id="account.topPanel.additionalAccess"/></div>
            <button className="ui-button2" type="button" onClick={() => this.handleShowPopupEx('permissions')}>
              <FormattedMessage id="account.topPanel.permissionsButton"/>
            </button>
          </div>
        ) : null}
        {/*{canAddFabricator ? (*/}
        {/*  <div className="acc-panel__block">*/}
        {/*    <div className="acc-panel__block-title">Add Store</div>*/}
        {/*    <button className="ui-button2" onClick={() => this.handleShowPopupEx('stores')} type="button">*/}
        {/*      Add Store*/}
        {/*    </button>*/}
        {/*  </div>*/}
        {/*) : null}*/}
        {this.currentEntityForAR() && this.currentEntityForAR().canSeeAddFabricatorButton() ? (
          <div className="acc-panel__block">
            <div className="acc-panel__block-title"><FormattedMessage id="account.topPanel.addFabricatorTitle"/></div>
            <button className="ui-button2" onClick={() => this.handleShowPopupEx('fabricators')} type="button">
              <FormattedMessage id="account.topPanel.addFabricatorButton"/>
            </button>
          </div>
        ) : null}
        {showMasterProfileSelection ? (
          <div className="acc-panel__block">
            <div className="acc-panel__block-title"><FormattedMessage id="account.topPanel.masterProfileTitle"/></div>
            <button className="ui-button2" type="button" onClick={this.masterProfileButtonClick}>
              <FormattedMessage id="account.topPanel.masterProfileButton"/>
            </button>
          </div>
        ) : null}
        {isEmployee || isCustomer || canChangePassword ? (
          <div className="acc-panel__block">
            <div className="acc-panel__block-title"><FormattedMessage id="account.topPanel.resetPasswordTitle"/></div>
            <button className="ui-button2" onClick={() => this.handleShowPopupEx('resetPassword')}>
              <FormattedMessage id="account.topPanel.resetPasswordButton"/>
            </button>
          </div>
        ) : null}
        {(isEmployee || isCustomer) && ((!isNew && !isCustomer) || canChangePassword) ? (
          <div className="acc-panel__block">
            <div className="acc-panel__block-title"><FormattedMessage id="account.topPanel.changePasswordTitle"/></div>
            <button className="ui-button2" onClick={() => this.handleShowPopupEx('changePassword')}>
              <FormattedMessage id="account.topPanel.changePasswordButton"/>
            </button>
          </div>
        ) : null}
        {isCustomer && !isNew && (isEmployee || isFabricator || isMasterFabricator) ? (
          <div className="acc-panel__block">
            <div className="acc-panel__block-title"><FormattedMessage id="account.topPanel.addNewQuoteTitle"/></div>
            <button className="ui-button2" onClick={() => this.createQuoteClick()}>
              <FormattedMessage id="account.topPanel.addNewQuoteButton"/>
            </button>
          </div>
        ) : null}
      </div>
    )
  }

}

const mapStateToProps = (store) => {
  const {accountPageInfo} = store.accountState;
  const {customerInfo, assignedMasterProfile} = store.newaccount;
  return {
    accountPageInfo,
    customerInfo,
    assignedMasterProfile,
    AR: AccessRights.get(store),
    masterProfile: getMasterProfile(store),
    formValues: (store.form && store.form.newEntity && store.form.newEntity.values) || {}
  };
};

const mapDispatchToProps = {
  showFabricatorsPopup,
  showAssignEntityPopup,
  showPermissionsPopup,
  setResetPasswordPopup,
  addNewQuote
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(AccountPageTopPanel)
);

